import React from "react";
import AppRoutes from "./routes";

export default function App(): React.ReactElement {
  return <AppRoutes />;
}
